var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0894 1.91085C18.3179 2.13931 18.3937 2.47925 18.2839 2.78314L12.8673 17.7831C12.8594 17.8049 12.8507 17.8263 12.841 17.8473C12.738 18.0721 12.5726 18.2627 12.3644 18.3962C12.1563 18.5298 11.9141 18.6008 11.6668 18.6008C11.4195 18.6008 11.1773 18.5298 10.9692 18.3962C10.766 18.2658 10.6035 18.0812 10.5001 17.8633L7.71234 12.2879L2.1369 9.50018C1.91905 9.39671 1.7344 9.23424 1.60401 9.03106C1.47042 8.8229 1.39941 8.58077 1.39941 8.33344C1.39941 8.08611 1.47042 7.84397 1.60401 7.63582C1.73759 7.42766 1.92813 7.26223 2.15298 7.1592C2.17398 7.14957 2.19537 7.14082 2.2171 7.13298L17.2171 1.71631C17.521 1.60657 17.8609 1.68238 18.0894 1.91085ZM9.34743 11.8313L11.6103 16.357L15.4472 5.73152L9.34743 11.8313ZM14.2687 4.55301L3.64327 8.38998L8.16892 10.6528L14.2687 4.55301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.843b7f99cc87c6bff71bbac6af455a12.svg";
export { ForwardRef as ReactComponent };